module.exports = __webpack_public_path__ + "609ddc173e36aba23c7eb31e9cf32970.jpg";